import clsx from 'clsx';

interface Props {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'xs' | 'sm' | 'md';
  disabled?: boolean;
  onClick?: () => void;
}

const Button = ({
  children,
  className,
  variant = 'primary',
  size = 'md',
  disabled,
  onClick,
}: Props) => {
  const getButtonColor = () => {
    switch (variant) {
      case 'primary':
        return 'bg-brand-tangerine text-brand-black hover:bg-brand-tangerine-dark';
      case 'secondary':
        return 'bg-brand-magnolia text-brand-black hover:bg-grayscale-400';
      case 'ghost':
        return 'bg-brand-granite text-brand-magnolia hover:bg-grayscale-600';
      default:
        return 'bg-brand-magnolia text-brand-black hover:bg-grayscale-400';
    }
  };

  const getButtonSize = () => {
    switch (size) {
      case 'xs':
        return 'px-3 text-sm h-[34px]';
      case 'sm':
        return 'px-4 text-lg h-[42px]';
      case 'md':
        return 'px-[18px] py-3 text-lg h-12';
      default:
        return 'px-4 py-2 text-lg h-12';
    }
  };

  const buttonClasses = clsx(
    'font-semibold rounded-lg flex-shrink-0 disabled:bg-grayscale-600 disabled:text-brand-black',
    getButtonColor(),
    getButtonSize(),
    className,
  );

  return (
    <button className={buttonClasses} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
